//Dependencies & helpers
import React, {useRef} from "react";
import {translation, UserContext} from "../../helpers";
//Components
import {Block} from "../../components";
//Styles
import "./HowTo.css";
//Carousel
import {ButtonBack, ButtonNext, CarouselProvider, DotGroup, Image, Slide, Slider} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import image_1 from '../../assets/how-to-use/Step_1.png';
import image_2 from '../../assets/how-to-use/Step_2.png';
import image_3 from '../../assets/how-to-use/Step_3.png';
import image_4 from '../../assets/how-to-use/Step_4.png';
import image_5 from '../../assets/how-to-use/Step_5.png';
import image_6 from '../../assets/how-to-use/Step_6.png';
import image_7 from '../../assets/how-to-use/Step_7_1.png';
import image_8 from '../../assets/how-to-use/Step_7_2.png';
import image_9 from '../../assets/how-to-use/Step_8.png';
import image_10 from '../../assets/how-to-use/Step_9.png';
import doctor from '../../assets/how-to-use/doctor.svg';
import patient from '../../assets/how-to-use/patient.svg';


const HowTo = () => {
  //Use translations
  const [state] = React.useContext(UserContext);
  const t = translation[state.lang].howto;

function forDoctor() {
  document.getElementById('doctor').style.display = 'block';
  document.getElementById('patient').style.display = 'none';
  console.log("click");
}
function forPatient() {
  document.getElementById('patient').style.display = 'flex';
  document.getElementById('doctor').style.display = 'none';
  console.log("click");
}
  const compRef = useRef(null);

  //Render blocks
  const returnBlocks = () => {
    return t.blocks.map((block, index) => {
      return <Block key={index} props={block} />;
    });
  };

  function isMobile() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  }

  return (
    <section id="how-to" ref={compRef}>
      {returnBlocks()}

      <div id="for-who">
        <div  onClick={forPatient} style={{borderRight: '2px solid #fff'}}>
          <img src={patient} alt={"Bruxoff patient"}/>
          <p>{t.patient}</p>
        </div>

        <div  onClick={forDoctor} >
          <img src={doctor} alt={"Bruxoff doctor"}/>
          <p>{t.doctor}</p>
        </div>
      </div>


        <CarouselProvider
            id="patient"
            visibleSlides={1}
            totalSlides={10}
            step={1}
            dragStep={1}
            naturalSlideWidth={1500}
            naturalSlideHeight={1062}
            isIntrinsicHeight
        >
          <Slider>
            <Slide index={0}>
              <Image src={image_1} />
              <div>{t.slide1}</div>
            </Slide>
            <Slide index={1}>
              <Image src={image_2} />
              <div>{t.slide2}</div>
            </Slide>
            <Slide index={2}>
              <Image src={image_3} />
              <div>{t.slide3}</div>
            </Slide>
            <Slide index={3}>
              <Image src={image_4} />
              <div>{t.slide4}</div>
            </Slide>
            <Slide index={4}>
              <Image src={image_5} />
              <div>{t.slide5}</div>
            </Slide>
            <Slide index={5}>
              <Image src={image_6} />
              <div>{t.slide6}</div>
            </Slide>
            <Slide index={6}>
              <Image src={image_7} />
              <div>{t.slide7}</div>
            </Slide>
            <Slide index={7}>
              <Image src={image_8} />
              <div>{t.slide8}</div>
            </Slide>
            <Slide index={8}>
              <Image src={image_9} />
              <div>{t.slide9}</div>
            </Slide>
            <Slide index={9}>
              <Image src={image_10} />
              <div>{t.slide10}</div>
            </Slide>
          </Slider>
          <ButtonBack>&#60;&#60;  Prev</ButtonBack>
          <DotGroup dotNumbers />
          <ButtonNext>Next  &#62;&#62;</ButtonNext>
        </CarouselProvider>

      {isMobile()? ( <div id="doctor">
        <iframe width="400" height="225" src="https://www.youtube-nocookie.com/embed/fTAak4CR4so?controls=0"
                title="Bruxoff" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>
      </div> ) : ( <div id="doctor">
        <iframe width="800" height="480" src="https://www.youtube-nocookie.com/embed/fTAak4CR4so?controls=0"
                title="Bruxoff" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen></iframe>
      </div> )}



    </section>
  );
};

export default HowTo;
